export const INDEXED_COURSES = [
  735,
  58,
  24388,
  29302,
  31950,
  22812,
  29303,
  22066,
  799,
  23983,
  28314,
  24907,
  25412,
  24372,
  29304,
  13367,
];
